import { render, staticRenderFns } from "./jiaohao.vue?vue&type=template&id=2ab83012&scoped=true&"
import script from "./jiaohao.vue?vue&type=script&lang=js&"
export * from "./jiaohao.vue?vue&type=script&lang=js&"
import style0 from "./jiaohao.vue?vue&type=style&index=0&id=2ab83012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab83012",
  null
  
)

export default component.exports